// extracted by mini-css-extract-plugin
export var brand = "_37-9";
export var button = "_37-0";
export var chevron = "_37-v";
export var chevronButton = "_37-w";
export var content = "_37-n";
export var danger = "_37-g";
export var dangerOutlined = "_37-h";
export var dark = "_37-l";
export var darkTheme = "_37-c";
export var extraSmall = "_37-4";
export var fullWidth = "_37-8";
export var ghost = "_37-d";
export var gray = "_37-t";
export var icon = "_37-p";
export var iconButton = "_37-s";
export var iconButtonBorder = "_37-x";
export var iconButtonBorderDark = "_37-y";
export var iconButtonBorderLight = "_37-z";
export var iconLeft = "_37-q";
export var iconRight = "_37-r";
export var large = "_37-1";
export var light = "_37-m";
export var medium = "_37-2";
export var micro = "_37-5";
export var nano = "_37-7";
export var outlined = "_37-k";
export var pending = "_37-a";
export var primary = "_37-i";
export var shadow = "_37-o";
export var small = "_37-3";
export var solidLight = "_37-e";
export var solidLightBrand = "_37-f";
export var spinner = "_37-u";
export var transparent = "_37-j";
export var warning = "_37-b";
export var wideNano = "_37-6";